export default "__VITE_ASSET__BzHw2T_f__"